import React from 'react';
import PropTypes from 'prop-types';

import DateRange from './DateRange';

import s from './CalendarContainer.css';


const CalendarContainer = ({ dates, handleTimeSlotSelection }) => {
  return (
    <section className={s.component}>
      {!dates ? (
        <h3 className={s.header}>
          Please select from options above to find an available appointment.
        </h3>
      ) : (
        <h3 className={s.header}>
          Select Appointment
        </h3>
      )}
      <DateRange
        dates={dates}
        handleTimeSlotSelection={handleTimeSlotSelection}
      />
    </section>
  );
};

CalendarContainer.propTypes = {
  dates: PropTypes.array,
  handleTimeSlotSelection: PropTypes.func,
};

export default CalendarContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/Calendar/CalendarContainer.js